<template>
  <expandable header="Apnoea Test Details" class="mb-0 px-3" :noBody="true">
    <div class="h5 py-2 px-2 section_subheader mt-3 mb-3">
      First Apnoea Details
    </div>
    <b-row>
      <b-col cols="12" md="4">
        <print-yes-no
          v-model.trim="form.first_apnea_status"
          @input="onInput"
          label="First Apnoea Status"
          :disabled="isDisabled"
        ></print-yes-no>
      </b-col>
      <b-col cols="12" md="4">
        <print-date-time
          v-model.trim="form.first_apnea_date"
          @input="onInput"
          label="First Apnoea Date/Time"
          :disabled="isDisabled"
        ></print-date-time>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="4">
        <print-file-input
          v-model.trim="form.first_apnea_file_upload_1"
          @input="onInput"
          :disabled="isDisabled"
          label="Pre Apnoea ABG"
          accept=".jpg,capture=camera,.jpeg,.png,.pdf"
          rules="file-image-pdf|file-size"
        ></print-file-input>
      </b-col>
      <b-col cols="12" md="4">
        <print-file-input
          v-model.trim="form.first_apnea_file_upload_2"
          @input="onInput"
          :disabled="isDisabled"
          label="Post Apnoea ABG"
          accept=".jpg,capture=camera,.jpeg,.png,.pdf"
          rules="file-image-pdf|file-size"
        ></print-file-input>
      </b-col>
    </b-row>
    <div class="h5 py-2 px-2 section_subheader mt-3 mb-3">
      2nd Apnoea Details
    </div>
    <b-row>
      <b-col cols="12" md="4">
        <print-yes-no
          v-model.trim="form.second_apnea_status"
          @input="onInput"
          :disabled="isDisabled"
          label="Second Apnoea Status"
        ></print-yes-no>
      </b-col>
      <b-col cols="12" md="4">
        <print-date-time
          v-model.trim="form.second_apnea_date"
          @input="onInput"
          :rules="secondApneaRules"
          label="Second Apnoea Date/Time"
          :disabled="isDisabled"
        ></print-date-time>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="4">
        <print-file-input
          v-model.trim="form.second_apnea_file_upload_1"
          @input="onInput"
          :disabled="isDisabled"
          label="Pre Apnoea ABG"
          accept=".jpg,capture=camera,.jpeg,.png,.pdf"
          rules="file-image-pdf|file-size"
        ></print-file-input>
      </b-col>
      <b-col cols="12" md="4">
        <print-file-input
          v-model.trim="form.second_apnea_file_upload_2"
          @input="onInput"
          :disabled="isDisabled"
          accept=".jpg,capture=camera,.jpeg,.png,.pdf"
          label="Post Apnoea ABG"
          rules="file-image-pdf|file-size"
        ></print-file-input>
      </b-col>
    </b-row>
  </expandable>
</template>

<script>
import moment from "moment";
import Expandable from "../../Expandable.vue";
import PrintYesNo from "../../ui/print/PrintYesNo.vue";
import PrintDateTime from "../../ui/print/PrintDateTime.vue";
import PrintFileInput from "../../ui/print/PrintFileInput.vue";
export default {
  props: {
    value: {},
    isDisabled: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    Expandable,
    PrintYesNo,
    PrintDateTime,
    PrintFileInput,
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    secondApneaRules() {
      let isBefore = false;
      let { first_apnea_date, second_apnea_date } = this.form;
      let first = moment(first_apnea_date, "YYYY-MM-DD HH:mm");
      if (first_apnea_date) {
        isBefore = moment(second_apnea_date, "YYYY-MM-DD HH:mm").isBefore(
          first
        );
      }
      console.log(isBefore);
      return isBefore ? "second_apnea_date" : "";
    },
  },
  methods: {
    onInput() {
      this.$emit("input", this.form);
    },
  },
  beforeMount() {
    this.form = this.value;
  },
};
</script>

<style></style>
